import useApiMutation from '@hooks/mutations/useApiMutation';

function useCheckForgottenCodeMutation(options) {
  return useApiMutation('post', `/v1/forgotten/check`, options);
}

export default useCheckForgottenCodeMutation;
